module.exports = __webpack_public_path__ + "static/media/sharat.e5544ca9.jpeg";